// v3.9.02: tela dedicada para o bootstrap inicial protegido.
import React from "react";

const STEPS = ["Preparando", "Hidratando", "Salvando", "Conferindo", "Pronto"];

function stepIndex(status, progress) {
  if (status === "ready") return 4;
  if (status === "post_delta_checking" || status === "post_delta_failed") return 3;
  if (status === "snapshot_completed") return 2;
  if (status === "snapshot_in_progress") return progress > 40 ? 2 : 1;
  return 0;
}

function statusText(status) {
  if (status === "post_delta_failed") return "A conferência final falhou. Tente novamente para liberar a fazenda.";
  if (status === "post_delta_checking") return "Conferindo alterações feitas durante a preparação inicial...";
  if (status === "snapshot_completed") return "Dados iniciais salvos. Preparando conferência final...";
  if (status === "snapshot_in_progress") return "Baixando e salvando o primeiro retrato seguro do servidor...";
  if (status === "aborted") return "Preparação interrompida. Toque em tentar novamente para continuar.";
  return "Preparando dados da fazenda...";
}

export function BootstrapGateScreen({ farm, state, onRetry, T = {} }) {
  const status = state?.status || "not_started";
  const pct = Math.min(100, Math.max(0, Number(state?.progress) || 0));
  const idx = stepIndex(status, pct);
  const failed = status === "post_delta_failed" || status === "aborted";
  const accent = failed ? (T.red || "#ef4444") : (T.accent || "#3b82f6");
  const bg = T.bg || "#0f172a";
  const card = T.card || "#111827";
  const border = T.border || "rgba(148,163,184,.28)";
  const text = T.text || "#f8fafc";
  const muted = T.muted || "#94a3b8";
  const farmName = farm?.name || farm?.nome || "fazenda";

  return (
    <div style={{ minHeight: "100dvh", background: bg, color: text, display: "flex", alignItems: "center", justifyContent: "center", padding: 22, fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ width: "min(680px, 100%)", background: card, border: `1px solid ${border}`, borderRadius: 24, boxShadow: "0 24px 80px rgba(15,23,42,.28)", padding: 24 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
          <div style={{ width: 42, height: 42, borderRadius: 16, background: `${accent}22`, color: accent, display: "grid", placeItems: "center", fontWeight: 800, fontSize: 18 }}>T</div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 20, fontWeight: 800, letterSpacing: "-.02em" }}>Preparando Fazenda</div>
            <div style={{ fontSize: 13, color: muted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{farmName}</div>
          </div>
        </div>

        <div style={{ fontSize: 14, lineHeight: 1.5, color: muted, marginBottom: 18 }}>
          {statusText(status)} Criação, edição, exclusão e ações operacionais serão liberadas após a conferência final.
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
          {STEPS.map((label, i) => {
            const done = i < idx;
            const active = i === idx;
            return (
              <React.Fragment key={label}>
                <span style={{ fontSize: 12, fontWeight: active ? 800 : 500, color: done ? accent : active ? text : muted }}>
                  {done ? "✓" : active ? "●" : "○"} {label}
                </span>
                {i < STEPS.length - 1 && <span style={{ color: muted, opacity: .7 }}>──</span>}
              </React.Fragment>
            );
          })}
        </div>

        <div style={{ height: 10, background: `${accent}22`, borderRadius: 999, overflow: "hidden", marginBottom: 10 }}>
          <div style={{ height: "100%", width: `${pct}%`, background: accent, borderRadius: 999, transition: "width .35s ease" }} />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center", color: muted, fontSize: 12 }}>
          <span>{pct}% concluído</span>
          <span>Visualização será aberta quando a base estiver segura.</span>
        </div>

        {failed && onRetry && (
          <button
            onClick={onRetry}
            disabled={state?.status === "post_delta_checking"}
            style={{ marginTop: 18, width: "100%", border: "none", borderRadius: 14,
              padding: "12px 16px", background: accent, color: "#fff", fontWeight: 800,
              cursor: state?.status === "post_delta_checking" ? "wait" : "pointer",
              opacity: state?.status === "post_delta_checking" ? 0.6 : 1 }}>
            Tentar novamente
          </button>
        )}
      </div>
    </div>
  );
}
